import { getDecagoniFrame } from './getDecagoniFrame'

const MAX_RETRIES = 9
const TIME_BEFORE_RETRYING = 600

// We get the `onLoad` event called for the script, but the script loads an iframe that takes a little bit more time to fix.
// This causes the chatbot button to overlap the sticky checkout cta up until we scroll past the cta that is in the page.
// To fix this, we set a timeout and establish a max number of retries, to avoid keep retrying if the iframe fails to load.
export const setChatbotPosition = ({
  bottom,
  attempt = 0,
}: {
  bottom: string
  attempt?: number
}) => {
  const chatbotIframe = getDecagoniFrame()

  if (!chatbotIframe) {
    if (attempt < MAX_RETRIES) {
      setTimeout(
        () => setChatbotPosition({ bottom, attempt: attempt + 1 }),
        TIME_BEFORE_RETRYING,
      )
    }
  } else {
    chatbotIframe.style.bottom = bottom
    chatbotIframe.style.overscrollBehavior = 'contain'
    chatbotIframe.style.pointerEvents = 'auto'
  }
}
